import React from "react"
import moment from "moment"
import clsx from "clsx"
import MyInputField from "@common-utils/fields/MyInputField"
import MyDateDayMonthYearHoursMinutesField from "@common-utils/fields/MyDateDayMonthYearHoursMinutesField"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"

export const InterviewCalendar: React.FC<{ helpers: any }> = ({ helpers }) => {
     return (
          <div className="p-6 rounded-4 mb-8">
               <h4 className="fw-boldest text-gray-800 mb-6 d-flex align-items-center">
                    <span className="badge badge-circle badge-success me-3">2</span> Planification
               </h4>
               <div className="row g-6">
                    <div className="col-12">
                         <label className="form-label fw-boldest text-gray-700 fs-7 text-uppercase required">Titre</label>
                         <MyInputField
                              name="reunionTitre"
                              value={helpers.values.reunionTitre}
                              onChange={val => helpers.setFieldValue("reunionTitre", val)}
                              isInvalid={!!helpers.errors.reunionTitre}
                         />
                    </div>
                    <div className="col-md-7">
                         <label className="form-label fw-boldest text-gray-700 fs-7 text-uppercase required">Date & Heure</label>
                         <MyDateDayMonthYearHoursMinutesField
                              name="reunionDate"
                              value={helpers.values.reunionDate}
                              minDate={moment().format()}
                              onChange={val => helpers.setFieldValue("reunionDate", val)}
                              isInvalid={!!helpers.errors.reunionDate}
                              placeholder="Date"
                         />
                    </div>
                    <div className="col-md-5">
                         <label className="form-label fw-boldest text-gray-700 fs-7 text-uppercase required">Durée (Min)</label>
                         <MyInputFormField formikProps={helpers} name="reunionDureeEnMinutes" type="number" placeholder={"Durée en minutes"} />
                    </div>
                    <div className="col-12">
                         <MyCheckboxFormField name="isCommentaire" text="Souhaitez-vous inclure une description / note interne dans le calendrier ?" formikProps={helpers} />
                    </div>
                    {helpers.values.isCommentaire && (
                         <div className="col-12 animate__animated animate__fadeIn">
                              <textarea
                                   className={clsx("form-control form-control-solid", helpers.errors.commentaire && "is-invalid")}
                                   rows={4}
                                   placeholder="Notes..."
                                   value={helpers.values.commentaire}
                                   onChange={e => helpers.setFieldValue("commentaire", e.target.value)}
                              />
                         </div>
                    )}
               </div>
          </div>
     )
}
